<script lang="ts">
  import MainLayout from "../../layout/MainLayout.svelte";
  import QualityDocumentManager from "../QualityDocument/QualityDocumentManager.svelte";
</script>

<MainLayout>
  <QualityDocumentManager entityName="manuale qualità" clfDocTypeCode="MANUQUALIT" withVersion={true} />
</MainLayout>
